import React from "react";
import PropTypes from "prop-types";
import capitalize from "lodash/capitalize";
import { Link } from "react-router-dom";
import DeleteModal from "../../common/DeleteModal";
import BlockModal from "../../common/BlockModal";
import DeleteInviteModal from "../../common/DeleteInviteModal";

const OrganizationUsersInvitesTable = ({
  users,
  invites,
  currentUser,
  sendInvite,
  deleteInvite,
  deleteUser,
  userBlock,
}) => {
  return (
    <table className="table-list">
      <thead>
        <tr>
          <th>FULL NAME / EMAIL</th>
          <th>ROLE</th>
          <th />
        </tr>
      </thead>
      <tbody>
        {users.map((user) => (
          <tr key={user.id} className="text-small">
            <td>
              <h5 className="mb-1">
                {user.fullName}{" "}
                {user.id === currentUser.id && (
                  <small>
                    (<strong className="text-link">me</strong>)
                  </small>
                )}
              </h5>
              <a href={`mailto:${user.email}${user.email}`}>{user.email}</a>
            </td>
            <td data-title="ROLE">{capitalize(user.type)}</td>
            <td className="table-actions nowrap">
              {user.id === currentUser.id ? (
                <div className="text-md-center">
                  <Link className="btn-transparent ml-n2 ml-md-0" to="/profile">
                    Edit profile
                  </Link>
                </div>
              ) : (
                <>
                  <Link
                    className="btn-transparent btn-icon ml-n2 ml-md-0"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Edit"
                    to={`/users/${user.id}/edit`}
                  >
                    <i className="icon-edit" />
                  </Link>
                  <a
                    className="btn-transparent btn-icon"
                    data-tooltip="tooltip"
                    data-placement="top"
                    title="Delete"
                    data-toggle="modal"
                    data-target={`#delete-modal-${user.id}`}
                  >
                    <i className="icon-delete" />
                  </a>
                  <a
                    className="btn-transparent btn-icon"
                    data-tooltip="tooltip"
                    data-placement="top"
                    title="Block"
                    data-toggle="modal"
                    data-target="#block-modal"
                  >
                    <i className="icon-block" />
                  </a>
                  <a
                    className="btn-transparent btn-icon"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Password reset"
                  >
                    <i className="icon-password-reset" />
                  </a>
                  <DeleteModal
                    deleteMethod={deleteUser}
                    id={user.id}
                    fullName={user.fullName}
                    entity={"User"}
                  />
                  <BlockModal
                    blockMethod={userBlock}
                    id={user.id}
                    fullName={user.fullName}
                    blocked={user.blocked}
                  />
                </>
              )}
            </td>
          </tr>
        ))}
        {invites
          .filter((invite) => invite.status !== "accepted")
          .map((invite) => (
            <tr key={invite.id} className="text-small">
              <td>
                <h5 className="mb-1">
                  <a href={`mailto:${invite.email}`}>{invite.email}</a>{" "}
                  <small className="d-inline-block text-small text-link-alt">
                    Invitation {invite.status}
                  </small>
                </h5>
              </td>
              <td data-title="ROLE" />
              <td className="table-actions nowrap text-md-center">
                <a
                  className="btn-transparent btn-icon ml-n2 ml-md-0"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Resend invite"
                  onClick={() =>
                    sendInvite.mutate({
                      id: invite.id,
                      email: invite.email,
                    })
                  }
                >
                  <i className="icon-envelope" />
                </a>
                <a
                  className="btn-transparent btn-icon"
                  data-tooltip="tooltip"
                  data-placement="top"
                  title="Cancel invite"
                  data-toggle="modal"
                  data-target={`#delete-invite-modal-${invite.id}`}
                >
                  <i className="icon-cancel" />
                </a>
                <DeleteInviteModal
                  deleteMethod={deleteInvite}
                  id={invite.id}
                  fullName={invite.email}
                  entity={"Invite"}
                />
              </td>
            </tr>
          ))}
      </tbody>
    </table>
  );
};

OrganizationUsersInvitesTable.propTypes = {
  users: PropTypes.array.isRequired,
  invites: PropTypes.array.isRequired,
  currentUser: PropTypes.object.isRequired,
  sendInvite: PropTypes.object.isRequired,
  deleteInvite: PropTypes.object.isRequired,
  deleteUser: PropTypes.object.isRequired,
  userBlock: PropTypes.object.isRequired,
};

export default OrganizationUsersInvitesTable;
